import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

/**
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {(isOpen: boolean) => any} props.onClick
 * @param {string | JSX.Element} props.title
 * @param {any} props.children
 * @param {any} props.className
 * @returns
 */
export const CollapsibleCard = ({
  isOpen,
  onClick,
  title,
  children,
  className
}) => {
  const [isCollapsed, setIsCollapsed] = useState(isOpen);
  const onArrowClick = () => {
    if (onClick && typeof onClick === "function") {
      onClick(isOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };
  const displayOpen = onClick && typeof onClick === "function" ? isOpen : isCollapsed;
  const collapsibleClasses = classNames(className, {
    "cursor-pointer px-2 py-1": !displayOpen,
    "px-4 py-2": displayOpen
  }, "border rounded ml-2");
  return /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, displayOpen ? /*#__PURE__*/React.createElement(FaChevronUp, {
    className: "cursor-pointer",
    onClick: onArrowClick
  }) : /*#__PURE__*/React.createElement(FaChevronDown, {
    className: "cursor-pointer",
    onClick: onArrowClick
  }), /*#__PURE__*/React.createElement("div", {
    className: collapsibleClasses,
    onClick: !displayOpen ? onArrowClick : undefined
  }, displayOpen ? children : title));
};
CollapsibleCard.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.element,
  className: PropTypes.string
};